<script setup>
//import { ref } from 'vue'
import { addIcon, deleteIcon } from '../../utils/icons';

import { useTestStore } from '../../stores/TestStore';
const testStore = useTestStore();

const props = defineProps({
  seccion_id: Number,
})


</script>

<template>

  <div class="leyendas-test my-5 pl-8">

    <div class="flex justify-between border-b-2 mb-5 pb-2">
      <h5 class="font-bold text-blue-700">Leyenda</h5>
      <button class="button-text-icon-sm" type="button" @click="testStore.add_leyenda(seccion_id)">
        <i v-html='addIcon'></i><span class="mx-2">Añadir</span>
      </button>
    </div>

    <div class="leyenda-test mb-1" >
      <div class="flex space-x-4 font-bold">
       <span class="w-1/4">Texto</span>
       <span class="w-1/4">Longitud</span>
       <span class="w-1/4">Posición de la etiqueta</span>
       <span class="w-12"></span>
      </div>
    </div> 

    <div v-for="leyenda in testStore.leyendas_seccion(seccion_id)" :key="leyenda.id">
      <div class="leyenda-test mb-1" >
        <div class="flex space-x-4">
          <input class="input-f w-1/4" v-model="leyenda.text" type="text" placeholder="Texto">
          <input class="input-f w-1/4" v-model="leyenda.longitud" type="number" placeholder="Puntos min">

          <select class="select-f w-1/4" v-model="leyenda.alineacion">
            <option value="left">Izquierda</option>
            <option value="center">Centro</option>
            <option value="right">Derecha</option>
          </select>

          <div class="w-12">
            <span class="button-icon-out-gray-red" type="button" @click="testStore.delete_leyenda(leyenda.id)">
              <i v-html='deleteIcon'></i>
            </span>    
          </div>
        </div>
      </div> 
    </div>



  </div>

</template>


<style lang="scss">

</style>